import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate, useParams } from "react-router-dom";

import api from "@/services/api";
import toast from "react-hot-toast";
import Loader from "@/components/Loader";
import SingleSelect from "../components/SingleSelect";
import MultiSelect from "../components/MultiSelect";

const ImpactPotential = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { id } = useParams();
  const [values, setValues] = useState();
  const [questions, setQuestions] = useState();

  useEffect(() => {
    fetchQuestions();
    fetchData();
  }, [id]);

  const fetchQuestions = async () => {
    try {
      const res = await api.post("/question/search", { limit: 300, startup: true });
      if (res.ok) {
        setQuestions(res.data);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const fetchData = async () => {
    try {
      const res = await api.get(`/company/${id}`);
      if (res.ok) {
        if (!res.data.plan) res.data.plan = "certified";
        setValues(res.data);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleChange = async () => {
    try {
      const res = await api.put(`/company/${id}`, values);
      if (!res.ok) throw new Error("Une erreur s'est produite lors de la mise à jour de la valeur");
      toast.success("Valeur mise à jour avec succès");
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleNext = async () => {
    await handleChange();
    navigate(`../form-finish`);
  };

  if (!values) return <Loader />;

  return (
    <div className="w-full space-y-8 px-40">
      <div>
        <label className="block text-gray-700 text-sm font-bold mb-2">
          {t("lable.does_your_offer_directly_address_issues_related_to_sustainable_development")} <span className="ml-2 text-red-500">*</span>
        </label>
        <div className="flex gap-10 mt-3">
          <div className="flex gap-4 items-center justify-center">
            <input
              type="radio"
              id="offer_directly_yes"
              name="is_offer_environment_issue_related"
              onChange={() => setValues((prev) => ({ ...prev, is_offer_environment_issue_related: true }))}
              checked={values?.is_offer_environment_issue_related === true}
            />
            <label className="block text-gray-700 text-sm font-bold" htmlFor="offer_directly_yes">
              {t("yes")}
            </label>
          </div>
          <div className="flex gap-4 items-center justify-center">
            <input
              type="radio"
              id="offer_directly_no"
              name="is_offer_environment_issue_related"
              onChange={() => setValues((prev) => ({ ...prev, is_offer_environment_issue_related: false }))}
              checked={values?.is_offer_environment_issue_related === false}
            />
            <label className="block text-gray-700 text-sm font-bold" htmlFor="offer_directly_no">
              {t("no")}
            </label>
          </div>
        </div>
      </div>

      <SingleSelect question={questions?.find((q) => q.key === "population_covered_amount")} values={values} setValues={setValues} />

      <div className="mb-6">
        <label className="block text-gray-700 text-sm font-bold mb-2">{t("lable.provide_details_on_the_proportion_of_the_population_addressed")}</label>
        <textarea
          className="input min-h-32"
          placeholder={t("placeholder_enter")}
          value={values?.population_covered_details || ""}
          onChange={(e) => setValues((prev) => ({ ...prev, population_covered_details: e.target.value }))}
        />
      </div>

      <SingleSelect question={questions?.find((q) => q.key === "completeness_degree")} values={values} setValues={setValues} />
      <SingleSelect question={questions?.find((q) => q.key === "certainty_degree")} values={values} setValues={setValues} />

      <SingleSelect question={questions?.find((q) => q.key === "expected_benefits_nature")} values={values} setValues={setValues} />

      <MultiSelect question={questions?.find((q) => q.key === "benefiting_areas")} values={values} setValues={setValues} />

      <MultiSelect question={questions?.find((q) => q.key === "benefiting_individuals")} values={values} setValues={setValues} />

      <SingleSelect question={questions?.find((q) => q.key === "integrated_extendt")} values={values} setValues={setValues} />
      <MultiSelect question={questions?.find((q) => q.key === "benefiting_goals")} values={values} setValues={setValues} />

      <div className="flex justify-between w-full">
        <Link to={`../form-impact-cse`} className="empty-button disabled:hover:bg-white px-10">
          {t("previous")}
        </Link>
        <div className="flex items-center gap-2">
          <button className="empty-button disabled:hover:bg-white px-10" onClick={handleChange}>
            {t("save")}
          </button>
          <button className="primary-button disabled:hover:bg-white px-10" onClick={handleNext}>
            {t("next")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ImpactPotential;
